import * as React from 'react';
import InsertChartOutlinedIcon from '@material-ui/icons/InsertChartOutlined';
import './rvChart.css';

interface ChartEmptyStateProps {
    title: string;
    hint?: string;
}

// Shown over a chart's drawing area when there is nothing to draw (every value is zero), instead of an empty grid and a legend that
// explains nothing. The chart stays mounted underneath, so its height does not change and it animates in when data arrives.
export const ChartEmptyState: React.FC<ChartEmptyStateProps> = ({ title, hint }) => (
    <div className="rv-chart-empty" role="status">
        <span className="rv-chart-empty-icon" aria-hidden={true}>
            <InsertChartOutlinedIcon />
        </span>
        <div className="rv-chart-empty-title">{title}</div>
        {hint ? <div className="rv-chart-empty-hint">{hint}</div> : null}
    </div>
);
